module.exports = __webpack_public_path__ + "static/media/mBank-Regular.9dd12af7.woff2";